
import { API_KEYS } from '@/utils/apiKeys';

/**
 * Get API key for a specific feature
 */
export const getApiKey = (feature: 'deepAnalysis' | 'recommended') => {
  return API_KEYS.openai[feature];
};
